import {
  OfferBannerState,
  OfferBannerStyles,
  WelcomeStyles
} from '../../models';
import { creditSummaryStyles } from '../offer-credit/styles.mocks';
import { offerBannerConfig } from '../offer-detail/config.mocks';
import { offerBanner } from '../offer-detail/content.mocks';
import { offerStyles } from '../offer-detail/styles.mocks';

export const welcomeStyles: WelcomeStyles = {
  congratsSection: {
    fontColor: '#0b1f66',
    fontSize: '18px',
    fontType: 'Whitney-Bold'
  },
  image: {
    position: 'left',
    width: 'small'
  },
  welcomeBanner: {
    fontColor: '#0b1f66',
    fontSize: '15px',
    fontType: 'Whitney-Book'
  },
  welcomeSection: {
    fontColor: '#0b1f66',
    fontSize: '0.9375rem',
    fontType: 'Whitney-Medium'
  }
};

export const offerBannerStyles: OfferBannerStyles = {
  creditSummary: creditSummaryStyles,
  offer: offerStyles,
  welcome: welcomeStyles
};

export const offerBannerStateMocks: OfferBannerState = {
  offer: offerBanner,
  offerConfig: offerBannerConfig,
  offerStyles: offerBannerStyles
};
